// PLUGINS IMPORTS //
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { CopyBlock, dracula } from 'react-code-blocks'
import dayjs from 'dayjs'

// COMPONENTS IMPORTS //
import Loading from 'Content/Shared/Components/Sections/Variables/Loading'
import Unfound from 'Content/Shared/Components/Sections/Variables/Unfound'
import Footer from 'Content/Shared/Layout/Footer/Footer'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { BlogsData } from 'Content/Screens/GeneralScreens/BlogScreens/BlogListScreen/Data'

import { GlobalStyles, iPhoneResolution } from 'Content/Shared/Styles/Theme'
import { BlogColors } from 'Redux/Types/BlogsTypes'

// REDUX //
import { getBlogInfoThunkCreator } from 'Redux/Reducers/BlogsReducer'
import {
  getBlogInfoSelector,
  getBlogLoadingStateSelector,
} from 'Redux/Selectors/BlogsSelector'

/////////////////////////////////////////////////////////////////////////////

interface PropsType {}

const BlogPostScreen: React.FC<PropsType> = () => {
  const { ID } = useParams<{ ID: string }>()
  // const blog = useSelector(getBlogInfoSelector)
  // const isLoading = useSelector(getBlogLoadingStateSelector)
  // const dispatch = useDispatch()

  // useEffect(() => {
  //   dispatch(getBlogInfoThunkCreator(ID))
  // }, [])

  const blog = BlogsData.find((x) => x.id === ID)
  const numOfCoffess = (blog ? blog.timeToRead : 0) / 10

  if (false) {
    return <Loading />
  } else if (blog && Object.values(blog).length > 0) {
    return (
      <>
        <Wrapper>
          <HeaderWrapper>
            <BlogTitle>{blog.title}</BlogTitle>
            <Callout>
              {dayjs(blog.date).format('DD')} {dayjs(blog.date).format('MMMM')}{' '}
              of {dayjs(blog.date).format('YYYY')}
            </Callout>

            <Callout>
              <span style={{ marginRight: '10px' }}>
                {'☕️'.repeat(numOfCoffess)}
              </span>
              {blog.timeToRead} minutes to read
            </Callout>
            <TagWrapper
              color={BlogColors[blog.tag] ? BlogColors[blog.tag] : '#fff'}
            >
              {blog.tag}
            </TagWrapper>
          </HeaderWrapper>
          <SectionsWrapper>
            {blog.paragraphs.map((paragraph) => {
              // const formattedString = paragraph
              //   .slice(6)
              //   .split('/n')
              //   .map((item) => `${item.trim()}\n`)
              //   .join('')

              return (
                <ItemWrapper>
                  <ItemTextWrapper>
                    {paragraph.title && <Subtitle>{paragraph.title}</Subtitle>}
                    {paragraph.text.map((text) => {
                      return (
                        <Paragraph
                          style={{
                            marginBottom: `${paragraph.spacing ? '12px' : 0}`,
                          }}
                        >
                          {text}
                        </Paragraph>
                      )
                    })}
                  </ItemTextWrapper>
                  {paragraph.code && (
                    <div style={{ textAlign: 'left' }}>
                      <CopyBlock
                        text={paragraph.code
                          ?.trim()
                          .replace(/^[^\S\r\n]+|[^\S\r\n]+$/gm, '')}
                        language={paragraph.lang ? paragraph.lang : 'js'}
                        showLineNumbers={true}
                        theme={dracula}
                        codeBlock
                      />
                    </div>
                  )}
                </ItemWrapper>
              )
            })}
          </SectionsWrapper>
        </Wrapper>
        <Footer />
      </>
    )
  } else {
    return <Unfound />
  }
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  margin-bottom: 130px;
  margin-top: ${GlobalStyles.insets.pageTop + 50}px;

  @media (max-width: ${iPhoneResolution}px) {
    margin-top: ${GlobalStyles.insets.pageTopMobile}px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`

const HeaderWrapper = styled.div`
  margin-bottom: 80px;
  margin-right: 120px;
  display: flex;
  // background: white;
  width: 60%;
  align-items: flex-start;
  flex-direction: column;
`

const BlogTitle = styled.h1``

/// Items types
const SectionsWrapper = styled.div`
  align-self: center;
  width: 67%;
`

const ItemWrapper = styled.div`
  margin-bottom: 26px;
`

const ItemTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
  margin-bottom: 15px;
`

const Callout = styled.div`
  color: darkGrey;
  margin-top: 5px;
`

const Subtitle = styled.h3``

const Paragraph = styled.div`
  margin-bottom: 3px;
  text-align: left;
  line-height: 22.5px;
  letter-spacing: 0.3px;
`

const TagWrapper = styled.div`
  border: 1px solid white;
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 50px;
  background-color: ${(props) => props.color};
  color: black;
  margin-top: 16px;
`

export default React.memo(BlogPostScreen, memoComparison)
